import { useEffect, useLayoutEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLocalStorage } from "usehooks-ts";
import AgentChatContainerUI from "@/components/agent/AgentChatContainerUI";
import TitleBar from "@/components/ui/TitleBar";
import { routes } from "@/configs/router.config/routes";
import { useWorkspaces } from "@/hooks/useWorkspaces";
import { useAppStore } from "@/stores/ui/useAppStore";

const AgentPage: React.FC = () => {
  const navigate = useNavigate();
  const [_, setIsSideBarOpen] = useLocalStorage("isSideBarOpen", true);
  const setIsAgentMode = useAppStore(s => s.setIsAgentMode);
  const { sessionCurrentWorkspaceId } = useWorkspaces();

  useLayoutEffect(() => {
    setIsSideBarOpen(true);
    setIsAgentMode(true);
  }, [setIsSideBarOpen, setIsAgentMode]);

  useEffect(() => {
    navigate(routes.agent(sessionCurrentWorkspaceId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionCurrentWorkspaceId]);

  return (
    <div className="">
      <TitleBar title="エージェント" />

      <div className="flex flex-1">
        {/* メインチャットエリア */}
        <div className="flex-1 flex flex-col h-[calc(100vh-100px)] bg-white overflow-hidden">
          <div className="h-full flex flex-col overflow-hidden">
            {/* チャットコンテンツ */}
            <div className="flex-1 overflow-hidden">
              <AgentChatContainerUI className="h-full" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgentPage;
